import Link from 'next/link';
import React from 'react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface ProfileBtnProps {
  userName?: string;
}

export default function ProfileBtn({
  userName = '',
}: ProfileBtnProps): React.ReactNode {
  return (
    <Link aria-label='Edit Profile' className='relative' href={`/user`}>
      <Avatar className='h-9 w-9 rounded-lg cursor-pointer bg-transparent'>
        <AvatarImage alt={`${userName || 'User'}'s profile picture`} src='' />
        <AvatarFallback
          aria-hidden='true'
          className='border border-orange-400 text-orange-900 bg-gradient-to-tr from-red-100 to-red-200 font-semibold hover:to-red-300 transition-colors text-xs'
        >
          {/* <User size={24} /> */}
          {userName.charAt(0).toUpperCase()}
        </AvatarFallback>
      </Avatar>
    </Link>
  );
}
